(() => {
  if (window.__inewerCollectionSwatches) return;
  window.__inewerCollectionSwatches = true;
  // Collection cards share one initializer; matching rules remain unchanged.
  const initializeFeaturedVariantLinks = (() => {
      if (window.__inewerFeaturedImageVariantLinks) return () => {};
      window.__inewerFeaturedImageVariantLinks = true;

      const imageKey = value => {
        try {
          const pathname = new URL(value, window.location.origin).pathname;
          return decodeURIComponent(pathname.split('/').pop() || '')
            .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*)?(?=\.[a-z0-9]+$)/i, '')
            .toLowerCase();
        } catch (error) {
          return String(value || '').split('?')[0].split('/').pop().toLowerCase();
        }
      };

      const inFlight = new WeakSet();
      const syncCard = async card => {
        if (inFlight.has(card)) return;
        inFlight.add(card);
        const handle = card.dataset.inewerProductHandle;
        const image = card.querySelector('.card__media img');
        if (!handle || !image) return;

        try {
          const response = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
          if (!response.ok) return;
          const product = await response.json();
          if (card.dataset.inewerUserColorSelected === 'true') return;
          const displayedKey = imageKey(image.getAttribute('src') || image.currentSrc || image.src);
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const matchingVariants = variants.filter(variant => {
            const source = variant.featured_image && variant.featured_image.src;
            return source && imageKey(source) === displayedKey;
          });
          const match = matchingVariants.find(variant => variant.available) || matchingVariants[0];
          if (!match || !match.id) return;

          card.querySelectorAll('a[href*="/products/"]').forEach(link => {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', match.id);
            link.href = `${url.pathname}${url.search}${url.hash}`;
          });
          card.dataset.inewerServerVariantLink = 'matched';
        } catch (error) {
          card.dataset.inewerServerVariantLink = 'fallback';
        }
      };

      return root => {
        const selector = '[data-inewer-featured-variant-link][data-inewer-server-variant-link="pending"]';
        if (root.matches?.(selector)) syncCard(root);
        root.querySelectorAll?.(selector).forEach(syncCard);
      };
  })();
  const revisions = new WeakMap();
  const loadImage = src => new Promise((resolve, reject) => {
    const image = new Image();
    const timer = setTimeout(() => reject(new Error('Color image unavailable')), 20000);
    image.onload = () => { clearTimeout(timer); resolve(); };
    image.onerror = () => { clearTimeout(timer); reject(new Error('Color image unavailable')); };
    image.src = src;
  });
  const navigationLinks = card => [...card.querySelectorAll(
    card.hasAttribute('data-inewer-holiday-card')
      ? 'a[href*="/products/"]'
      : '.card__heading a[href], a.inewer-shop-all-swatches__more[href]'
  )];
  const syncMoreLink = card => {
    const heading = card?.querySelector('.card__heading a[href]');
    if (!heading) return;
    card.querySelectorAll('a.inewer-shop-all-swatches__more').forEach(link => { link.href = heading.href; });
  };
  const setVariantLinks = (card, id) => {
    navigationLinks(card).forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.delete('option_values');
      url.searchParams.set('variant', id);
      link.href = url.href;
    });
  };
  const validButton = button => /^\d+$/.test(button.dataset.variantId || '') && Boolean(button.dataset.imageSrc) && !button.disabled;
  const initialize = root => {
    const rows = root.querySelectorAll?.('[data-inewer-card-swatches]') || [];
    rows.forEach(row => {
      if (row.dataset.initialized) return;
      row.dataset.initialized = 'true';
      const card = row.closest('.product-card-wrapper');
      syncMoreLink(card);
      const selected = row.querySelector('[data-inewer-swatch][aria-pressed="true"]');
      if (!card || !selected || !validButton(selected)) return;
      navigationLinks(card).forEach(link => {
        const url = new URL(link.href, location.origin);
        if (url.searchParams.has('option_values')) {
          url.searchParams.delete('option_values');
          url.searchParams.set('variant', selected.dataset.variantId);
          link.href = url.href;
        }
      });
    });
  };
  document.addEventListener('click', async event => {
    const more = event.target.closest?.('[data-inewer-card-swatches] a.inewer-shop-all-swatches__more');
    if (more) {
      syncMoreLink(more.closest('.product-card-wrapper'));
      return;
    }
    const button = event.target.closest?.('[data-inewer-card-swatches] [data-inewer-swatch]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!validButton(button)) return;
    const row = button.closest('[data-inewer-card-swatches]');
    const card = row.closest('.product-card-wrapper');
    const image = card?.querySelector('.card__media > .media.media--hover-effect > img:first-child');
    if (!card || !image) return;
    card.dataset.inewerUserColorSelected = 'true';
    card.dataset.inewerColorHydrated = 'true';
    card.classList.remove('inewer-color-pending');
    const revision = (revisions.get(card) || 0) + 1;
    revisions.set(card, revision);
    try { await loadImage(button.dataset.imageSrc); }
    catch { if (revisions.get(card) === revision) card.dataset.inewerSwatchState = 'image-unavailable'; return; }
    if (revisions.get(card) !== revision || !card.isConnected) return;
    // Other collections retain their existing fixed Hover image.
    image.removeAttribute('srcset');
    image.src = button.dataset.imageSrc;
    image.alt = button.dataset.imageAlt || button.dataset.color;
    if (card.hasAttribute('data-inewer-holiday-card')) {
      const hoverImage = image.parentElement.querySelector('img:nth-child(2)');
      if (hoverImage) {
        // No verified same-color secondary: reuse the loaded primary image.
        hoverImage.removeAttribute('srcset');
        hoverImage.src = button.dataset.imageSrc;
        hoverImage.alt = image.alt;
      }
    }
    setVariantLinks(card, button.dataset.variantId);
    syncMoreLink(card);
    row.querySelectorAll('[data-inewer-swatch]').forEach(swatch => {
      const selected = swatch === button;
      swatch.setAttribute('aria-pressed', String(selected));
      swatch.querySelector('.featured-dresses__swatch')?.classList.toggle('featured-dresses__swatch--selected', selected);
    });
    card.dataset.inewerSelectedVariant = button.dataset.variantId;
    card.dataset.inewerSelectedColor = button.dataset.color;
    card.dataset.inewerSwatchState = 'ready';
  }, true);
  const start = () => {
    initialize(document);
    initializeFeaturedVariantLinks(document);
    new MutationObserver(changes => changes.forEach(change => change.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      initializeFeaturedVariantLinks(node);
      if (node.matches('[data-inewer-card-swatches]')) initialize(node.parentElement);
      else initialize(node);
    }))).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
